<template>
  <div style="margin-top:30px">
    <tabla  Titulo="Responsable" :Cabecera="Cabecera" :Items="Items" :Excel="false" :Crear="true" />
  </div>
</template>
<script>
import tabla from "@/components/responsable/tabla.vue"
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Responsable",
  components : {
    tabla
  },
  created(){
    const data = {menu1:1,menu2:0,submenu2:0,menu3:0,submenu3:0};
    this.CargarMenu(data);
    this.cargarResponsable();
  },
  data(){
    return{
      Cabecera:[
        {text:'Id',value:'id'},
        {text:'N° Documento',value:'RES_NumeroDocumento'},
        {text:'Responsable',value:'NombreCompleto'},
        {text:'Direccion',value:'RES_Direccion'},
        {text:'Email',value:'RES_Email'},
        {text:'Celular',value:'RES_Telefono'},
        {text:'Accion',value:'Accion'}
      ]
    }
  },
  methods:{
    ...mapActions('responsable',['cargarResponsable']),
    ...mapActions('nav',['CargarMenu'])
  },

  computed:{
    ...mapGetters('responsable',['Items'])    
  }


};
</script>




